namespace TabAurous.Inventory {
    export interface MixingRow {
        TransId?: number;
        TransDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        AutoPosting?: boolean;
        UserId?: number;
        EmployeeId?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        Details?: MixingDetailsRow[];
        ItemsDetails?: MixingItemsRow[];
        PostingDate?: string;
        IsPosted?: boolean;
        Username?: string;
    }

    export namespace MixingRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.Mixing';
        export const deletePermission = 'Inventory:Mixing:Delete';
        export const insertPermission = 'Inventory:Mixing:Add';
        export const readPermission = '*';
        export const updatePermission = 'Inventory:Mixing:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            AutoPosting = "AutoPosting",
            UserId = "UserId",
            EmployeeId = "EmployeeId",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            Details = "Details",
            ItemsDetails = "ItemsDetails",
            PostingDate = "PostingDate",
            IsPosted = "IsPosted",
            Username = "Username"
        }
    }
}
